import { render, staticRenderFns } from "./CmgGroupOrderConfirmation.vue?vue&type=template&id=dac72740&scoped=true&lang=pug"
import script from "./cmg-group-order-confirmation.ts?vue&type=script&lang=ts&external"
export * from "./cmg-group-order-confirmation.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgGroupOrderConfirmation.vue?vue&type=style&index=0&id=dac72740&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac72740",
  null
  
)

export default component.exports